import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type UserStateType = {
  role: string
  merchantId: number
  userName:string
  mobile:string
  merchantName:string,
  menu:any
}

const INIT_STATE: UserStateType = { role: '', merchantId: 0,userName:'',mobile:'', merchantName:'', menu: {} }

export const userSlice = createSlice({
  name: 'user',
  initialState: INIT_STATE,
  reducers: {
    setUser: (state: UserStateType, action: PayloadAction<UserStateType>) => {
      return action.payload 
    },
    setMerchant: (state: UserStateType, action: PayloadAction<{merchantId:number,merchantName:string}>) => {
      return {
        ...state,
        merchantId: action.payload.merchantId,
        merchantName: action.payload.merchantName,
      }
    },
  },
})

export const { setUser,setMerchant } = userSlice.actions

export default userSlice.reducer
